const TestProcessSingle = () => import("@/pages/lab/testprocess/TestProcessSingle");
const TestProcessIndex = () => import("@/pages/lab/testprocess/TestProcessIndex");
const TestProcessDetail = () => import("@/pages/lab/testprocess/TestProcessDetail");
const TestProcessAdd = () => import("@/pages/lab/testprocess/TestProcessAdd");
const TestProcessEdit = () => import("@/pages/lab/testprocess/TestProcessEdit");
const TestProcessSort = () => import("@/pages/lab/testprocess/TestProcessSort");
const TestTaskAdd = () => import("@/pages/lab/testtask/TestTaskAdd");
export class TestProcessRoutes {
  constructor() {
    this.route_root = "test-processes/";
    this.type_single = "Test Process";
    this.type_plural = "Test Processes";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          }
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: TestProcessIndex,
            meta: { requiresAuth: true }
          },
          {
            path: "add",
            name: `New ${this.type_single}`,
            component: TestProcessAdd,
            meta: { requiresAuth: true }
          },
          {
            path: ":test_process_id",
            component: TestProcessSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: TestProcessDetail,
                meta: { requiresAuth: true }
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: TestProcessEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "sort",
                name: `Sort ${this.type_single}`,
                component: TestProcessSort,
                meta: { requiresAuth: true }
              },
              {
                path: "task/add",
                name: `Add ${this.type_single} Task`,
                component: TestTaskAdd,
                meta: { requiresAuth: true }
              }
            ]
          }
        ]
      }
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
